import type { ReactNode } from "react";

import { cn } from "@monorepo-apps/ui/src/lib/utils";

interface PageHeaderProps {
  eyebrow?: ReactNode;
  title: string;
  summary?: ReactNode;
  actions?: ReactNode;
  /** Dark navy band (Mission Control) — use on architecture pages for readable chrome. */
  tone?: "default" | "dark";
}

export function PageHeader({
  eyebrow,
  title,
  summary,
  actions,
  tone = "default",
}: PageHeaderProps) {
  const dark = tone === "dark";
  return (
    <header
      data-slot="page-header"
      className={cn(
        "flex flex-col gap-1 border-b px-6 py-5 sm:flex-row sm:items-end sm:justify-between",
        dark
          ? "border-white/12 bg-[oklch(0.13_0.025_250)] text-[oklch(0.93_0.008_240)]"
          : "border-border/60"
      )}
    >
      <div className="flex flex-col gap-1">
        {eyebrow ? <span className={dark ? "eyebrow-bright" : "eyebrow"}>{eyebrow}</span> : null}
        <h1 className={cn("text-base font-medium tracking-tight", dark && "text-white")}>
          {title}
        </h1>
        {summary ? (
          <p
            className={cn(
              "font-data text-[11px] leading-snug tabular-nums",
              dark ? "text-white/85" : "text-muted-foreground"
            )}
          >
            {summary}
          </p>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </header>
  );
}
